import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/locale";
import bsview from "bsview-3.0";
// import axios from "./utils/axios";
import "bsview-3.0/dist/styles/bsview.css";
import "./styles/index.less";
import { cloneDeep } from "lodash";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// import i18n from './i18n'

window.moment = moment;
window.cloneDeep = cloneDeep;
Vue.component("treeselect", Treeselect);
let themeColor = "#399";
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false;

store.dispatch("getLoginInfo").then(res => {
  Vue.use(bsview, {
    themeColor: res.loginThemeColor ? res.loginThemeColor : themeColor,
    i18n: (key, value) => i18n.t(key, value),
  });
  store.state.platformName = res.platformName;
  store.state.isShowI18n = res.useI18n;
  store.state.platformEnglishName = res.platformEnglishName;
  store.state.currentLang = res.lang || "zh-CN";
  new Vue({
    el: "#app",
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount("#app");
});
